module.exports = __webpack_public_path__ + "static/VM-Hover@2x-637ee3146817a9baa7f759c33ceaf79e.png";